import { createContext } from "react";

const SidebarContext = createContext({
    // Entity being edited
    entity: null,
    setEntity: () => {},

    // Show/hide sidebar
    show: false,
    setShow: () => {},

    // Current active page (for multi-page sidebars)
    currentPage: null,
    setCurrentPage: () => {},

    // Runtime data shared across pages (not persisted until save)
    runtimeData: {},
    setRuntimeData: () => {},

    // Final data to be persisted (emitted on save)
    emittedData: {},
    setEmittedData: () => {},

    // Loading states
    isSaving: false,
    isDeleting: false,

    // Validation state
    pageValidators: {}, // { pageName: validatorFunction }
    registerPageValidator: () => {},
    unregisterPageValidator: () => {},
    isValid: true, // Overall validity

    // Callbacks
    onSave: () => {},
    onDelete: () => {},
    onDiscard: () => {},
    onNext: () => {},

    // Metadata
    metadata: null, // e.g., "Created by John at 2024-01-15"
});

export default SidebarContext;
